export const links = {
  RGCams: "https://rgcams.com/landing/click/?AFNO=1-4",
  // eslint-disable-next-line
  RGCamsDesktop: "https://prtord.com/?siteId=wl3&cobrandId=257522&superCategoryName=&categoryName=&pageName=home&performerName=&prm[psid]=RedGIFs&prm[pstool]=205_1&prm[psprogram]=cbrnd&prm[campaign_id]=&subAffId={SUBAFFID}&prm[utm_source]=menu&filters=",
};
